var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgAnnotationIconCharts = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 18,
  height: 18,
  viewBox: "0 0 18 18",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M9.6 13.366h4.939c.508 0 1.003-.197 1.373-.558.372-.363.588-.863.588-1.392V4.45c0-.53-.216-1.03-.588-1.392A1.967 1.967 0 0 0 14.54 2.5H3.46c-.508 0-1.003.197-1.373.558A1.944 1.944 0 0 0 1.5 4.45v6.966c0 .53.216 1.03.588 1.392.328.32.754.51 1.2.55l.059 1.291v.024l.002.023c.032.412.194.8.458 1.111.263.31.614.528 1.001.63l.009.002.008.002c.154.038.312.058.47.059h.012a1.973 1.973 0 0 0 1.463-.654l2.83-2.48Z",
  fill: "#C4CAD3",
  stroke: "#fff",
  strokeWidth: 3
})));
SvgAnnotationIconCharts.displayName = "SvgAnnotationIconCharts";
export { SvgAnnotationIconCharts as ReactComponent };
export default SvgAnnotationIconCharts;